<template>
  <v-card
    rounded="10"
    @click="navigateToNode"
    @keydown.enter.prevent="navigateToNode"
    @keydown.space.prevent="navigateToNode"
    role="link"
    tabindex="0"
    elevation="0"
  >
    <v-card-text>
      <v-row>
        <v-col cols="4" sm="3" class="d-flex justify-center">
          <v-icon size="86px">mdi-folder</v-icon>
        </v-col>
        <v-col cols="4" sm="5" class="d-flex align-center">
          <div class="item-title">
            {{ node.name }}
          </div>
        </v-col>
        <v-col cols="4" sm="3" class="d-flex align-center">
          <div>
            Updated at: {{ isoToDate(node.updatedat) }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { isoToDate } from '@/components/formatters.js';

export default {
  name: 'AccesslinkListNodeItem',
  methods: {
    isoToDate,
    navigateToNode() {
      this.$router.push({ name: 'accesslink:view:node', params: { nodeid: this.node.id } });
    },
  },
  components: {},
  props: {
    node: {
      type: Object,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.item-title {
  font-weight: bolder;
  word-break: break-all;
}
</style>
